import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { DagjeuitErrorHandler } from './app/shared/dagjeuit.error.handler';
import { LocationStrategy } from '@angular/common';
import { NsHashLocationStrategy } from './app/shared/ns.hash.location.strategy';
import { FilterHelper } from './app/shared/helpers/filter.helper';
import { FilterSortService } from './app/shared/services/filter.sort.service';
import { FormBuilderHelper } from './app/shared/helpers/formbuilder.helper';
import { LabelService } from './app/shared/services/label.service';
import { StateHelper } from './app/shared/helpers/state.helper';
import { UrlHelper } from './app/shared/helpers/url.helper';
import { EventBus } from './app/shared/utils/eventbus';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { WalksModule } from './app/components/walks/walks.module';
import { DealsModule } from './app/components/deals/deals.module';
import { SharedModule } from './app/shared/shared.module';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      WalksModule,
      DealsModule,
      SharedModule.forRoot(),
    ),
    {
      provide: ErrorHandler,
      useClass: DagjeuitErrorHandler,
    },
    {
      provide: LocationStrategy,
      useClass: NsHashLocationStrategy,
    },
    FilterHelper,
    FilterSortService,
    FormBuilderHelper,
    LabelService,
    StateHelper,
    UrlHelper,
    EventBus,
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err)); // eslint-disable-line  no-console
